import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSearchParams, Link } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';

export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    const result = await resetPassword(token, password);
    setLoading(false);
    if (result.success) {
      setMessage(result.message);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-8" data-testid="reset-password-page">
      <div className="w-full max-w-sm space-y-8 bg-white border border-zinc-200 p-8">
        <div>
          <h1 className="text-4xl font-black tracking-tighter text-zinc-950">New Password</h1>
          <p className="mt-2 text-sm text-zinc-500">Set your new password below</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm" data-testid="reset-error">{error}</div>}
          {message && (
            <div className="bg-green-50 border border-green-200 text-green-700 text-sm p-3 rounded-sm" data-testid="reset-success">
              {message} <Link to="/login" className="underline font-medium">Sign in now</Link>
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">New Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-zinc-300 focus:border-black" data-testid="reset-password-input" required minLength={6} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="confirm" className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">Confirm Password</Label>
            <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-none border-zinc-300 focus:border-black" data-testid="reset-confirm-input" required minLength={6} />
          </div>

          <Button type="submit" disabled={loading} className="w-full rounded-none bg-black text-white hover:bg-zinc-800" data-testid="reset-submit-button">
            {loading ? 'Resetting...' : 'Reset Password'}
          </Button>
        </form>

        <Link to="/login" className="block text-sm text-zinc-500 hover:text-black transition-colors">Back to sign in</Link>
      </div>
    </div>
  );
}
